import React from "react";

export default function ButtonPrimary({label, onClick, isLoading=false, customClass=""}) {
    function showLoader() {
        if (isLoading)
            return (
                <div className="spinner-border" role="status">                    
                </div>
            )
    }

    return (
        <button className={`custom-btn-primary ${customClass}`} onClick={onClick}>
            <label>{label}</label>
            {showLoader()}
        </button>
    )
}